module.exports = __webpack_public_path__ + "img/image 41.f9027da7.svg";